/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IReadOnlyListOfIncidentRecordSummaryDto } from './iReadOnlyListOfIncidentRecordSummaryDto.schema';

export const PagedResultOfIncidentRecordSummaryDto = zod.object({
  "items": zod.lazy(() => IReadOnlyListOfIncidentRecordSummaryDto).optional(),
  "pageNumber": zod.number().optional(),
  "pageSize": zod.number().optional(),
  "totalItems": zod.number().optional(),
  "totalPages": zod.number().optional(),
  "hasNextPage": zod.boolean().optional(),
  "hasPreviousPage": zod.boolean().optional()
});

export type PagedResultOfIncidentRecordSummaryDto = zod.input<typeof PagedResultOfIncidentRecordSummaryDto>;
export type PagedResultOfIncidentRecordSummaryDtoOutput = zod.output<typeof PagedResultOfIncidentRecordSummaryDto>;
